module.exports = __webpack_public_path__ + "img/logo_tnklab.2102d8d4.png";